<template>
    <div class="mainBox_page">
        <div class="mainBox round uk-flex uk-flex-column">
            <div class="main round uk-flex uk-flex-column uk-flex-item-1">

                <div class="pageTop"></div>

                <div class="uk-flex-item-1 mainInner p20">
                    <div class="mainInner_step_2">
                    <div
                        class="orderInfo uk-panel uk-panel-box-secondary uk-panel-box roundSmall uk-margin-bottom"
                    >
                        <div class="uk-flex uk-flex-space-between uk-margin-small-bottom">
                        <div class="uk-margin-right">訂單號</div>
                        <div class="hideText" @click="changCopyText(orderParams.order_sn)">
                            <span class="uk-text-bold">{{orderParams.order_sn}}</span
                            >
                            <!-- <span class="uk-icon-copy cursor"></span> -->
                        </div>
                        </div>

                        <div class="uk-flex uk-flex-space-between uk-margin-small-bottom">
                        <div class="uk-margin-right">訂單金額</div>
                        <div class="hideText">
                            {{orderParams.price}}
                            <span class="uk-article-meta">{{orderParams.unit}}</span>
                        </div>
                        </div>

                        <div class="uk-flex uk-flex-space-between uk-margin-small-bottom">
                        <div class="uk-margin-right">商戶網站</div>
                        <div class="hideText">
                            <span class="uk-text-bold">https://happytalk.tw/</span>
                        </div>
                        </div>

                    </div>

                        <div class="uk-text-center info_content_box" style="min-height: 250px;">
                            <!-- :logoScale="0.3"
                                :dotScale="0.7"
                                :logoBackgroundColor="'#fff'"
                                :logoCornerRadius="5" -->
                            <vue-qr
                                :logoSrc="require('./weChatQrCodePay_img/code_logo.png')"
                                :text="orderParams.pay_url"
                                :size="250"
                                :margin="10"
                                :logoScale="0.15"
                                colorDark="black"
                                colorLight="white"
                                :callback="changCodeCallback"
                            />
                        </div>

                        <div class="uk-text-center uk-margin-bottom">
                            <span class="uk-h2">
                                <b>{{orderParams.price}}</b>
                            </span>
                            <span class="uk-h4">
                                <b class="ipp-text-black">{{orderParams.unit}}</b>
                            </span>
                        </div>

                        <div class="uk-flex uk-flex-center uk-flex-middle uk-margin-bottom">
                            <span class="uk-h4">
                                <b class="text-gray">掃描二維碼進行支付 </b>
                            </span>
                        </div>

                    </div>
                </div>

                <div class="uk-flex uk-flex-space-between actionBottom"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { Base64 } from "js-base64";
import VueQr from 'vue-qr'
import { Toast } from 'vant';
import h5Copy from '@/common/js/junyi-h5-copy.js'
export default {
  name: "weChatQrCodePay",
  data() {
    return {
      orderParams: {
        pay_url: '',
      },
      timerId: null,
      timeNum: 1000,
      orderStatus: 0,
    };
  },
  components: { VueQr },
  mounted() {
    this.orderParams = JSON.parse(Base64.decode(this.$route.query.orderParams));
    console.log(this.orderParams);
    this.getHuitechOrderStatus()
  },
  methods:{
    changCodeCallback(dataUrl){
        // console.log(dataUrl)
    },
    // 检查订单状态
    getHuitechOrderStatus(){
        this.$axios
          .get(
            `../api/api1.php?c=commodity._getHuitechOrderStatus&order_sn=${this.orderParams.order_sn}`
          )
          .then(res => {
            // console.log(res)
            if (res.data.code == 0) {
                this.orderStatus = res.data.data.status
              if (this.orderStatus == 8) {
                if (this.timerId) {
                    clearTimeout(this.timerId)
                }
                this.$router.replace({
                    path: 'successResult',
                })
              }
            }else{
                // Toast(res.data.message)
            }
          })
          .catch(error => {
            // console.error('数据加载失败:', error);
          })
          .finally((res) => {
            // console.log('数据加载完成');
            if (this.orderStatus != 8) {
                this.timerId = setTimeout(() => {
                this.getHuitechOrderStatus()
            },this.timeNum)
            }
          })
    },
    changCopyText(str){
        const h5CopyDom = h5Copy(str)
        if (!h5CopyDom) {
            Toast('複製失敗')
        }else{
            Toast('複製成功')
        }
    }
  },
  destroyed(){
    if (this.timerId) {
        clearTimeout(this.timerId)
    }
  }
};
</script>

<style lang="stylus" scoped>
* {
    box-sizing: border-box;
}
.round {
  border-radius: 16px;
}

.uk-flex {
  display: flex;
}

.uk-flex-column {
  flex-direction: column;
}

.uk-flex-item-1 {
  flex: 1;
}

.p20 {
  padding: 0 20px;
}

.uk-panel-box {
  border-radius: 2px;
}

.uk-panel {
  display: block;
  position: relative;
}

.uk-panel, .uk-panel:hover {
  text-decoration: none;
}

.uk-panel-box {
  padding: 15px;
  background: #fafafa;
  color: #444;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.uk-panel-box-secondary {
  background-color: #fff;
  color: #444;
}

.uk-margin-bottom {
  margin-bottom: 15px !important;
}

.roundSmall {
  border-radius: 12px;
}

.uk-panel-box {
  padding: 10px;
}

.uk-panel-box-secondary {
  color: #000;
}

.uk-panel:after, .uk-panel:before {
  content: '';
  display: table;
}

.uk-panel:after {
  clear: both;
}

.uk-flex-space-between {
  // -ms-flex-pack: justify;
  // -webkit-justify-content: space-between;
  justify-content: space-between;
}

.uk-margin-small-bottom {
  margin-bottom: 5px !important;
}

.uk-margin-right {
  margin-right: 15px !important;
}

h1, .uk-h1, h2, .uk-h2, h3, .uk-h3, h4, .uk-h4, h5, .uk-h5, h6, .uk-h6 {
    font-family: ProximaNova, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    font-weight: 300;
    color: #333;
}
.uk-h2, h2 {
    font-size: 24px;
    line-height: 30px;
}

b, strong {
    font-weight: 500 !important;
}
b, strong {
    font-weight: 700;
}

.uk-flex-center {
    // -ms-flex-pack: center;
    // -webkit-justify-content: center;
    justify-content: center;
}

.uk-flex-middle {
    // -ms-flex-align: center;
    // -webkit-align-items: center;
    align-items: center;
}

.ipp-text-black {
    color: #303030 !important;
}

audio, canvas, img, svg, video {
    max-width: 100%;
    height: auto;
    box-sizing: border-box;
}

audio, canvas, iframe, img, svg, video {
    vertical-align: middle;
}

.mainBox_page{
    width 100%;
    background-color #0055e4;
}

.mainBox {
  width: 550px;
  margin: 0 auto;
  position: relative;
  height 100vh;
//   height: 100%;
  padding: 25px;
  line-height: 1.6;
  font-size: 14px;
  font-weight: 700;
}

.main {
  background: #fff;
  position: relative;
  overflow: hidden;
}

.pageTop {
  height: 40px;
  position: relative;
}

.mainInner {
  overflow: hidden;
  overflow-y: auto;
  position: relative;
}

.mainInner_step_2, #mainInner {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.mainInner_step_2 {
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  position: relative;
  padding-top: 10px;
}

.hideText {
  overflow: hidden;
  word-break: break-all;
  text-align: right;
  flex: 1;
}

.uk-text-bold {
  font-weight: 700;
}
.uk-article-meta {
    font-size: 12px;
    line-height: 18px;
    color: #999;
}
.uk-text-center {
    text-align: center !important;
}
.actionBottom {
    padding: 15px 20px;
    border-top: .4px solid #0000001a;
    z-index: 500;
    background-color: #fff;
}
@media (max-width: 768px) {
    .mainBox {
        width: 100%;
        padding: 0;
    }
    .round {
        border-radius: 0;
    }
}
</style>
